import { CollectionNode } from "../collectionNode.model"
import { PremiumHomePage } from "../collection/premiumHomePage.model"
import { PremiumSectionPage } from "../collection/premiumSectionPage.model"
import { GTMData } from "../../utils/types"

abstract class CollectionGTM implements GTMData {
    protected _collection

    get dimension2(): string[] {
        return this._collection.topLevelSubjects
    }
    get dimension3(): string {
        return this._collection.contentProjects
    }
    get dimension4(): string {
        return this._collection.resourceGradesDisplay
    }
    get dimension11(): string {
        return this._collection.brands.map((b) => b.name).join(", ")
    }
    get dimension12(): string {
        return ""
    }
    get dimension13(): string {
        return ""
    }
    get dimension14(): string {
        return ""
    }
    get dimension28(): string {
        return ""
    }
    get dimension29(): string {
        return ""
    }
    get dimension35(): string {
        return ""
    }
    get gtmObject() {
        return this._collection
    }
}

interface CollectionGTMConstructor {
    new (_collection: CollectionNode)
}

interface PremiumCollectionGTMConstructor {
    new (_collection: PremiumHomePage)
}

interface PremiumSubCollectionGTMConstructor {
    new (_collection: PremiumSectionPage)
}

export const StandardCollectionGTM: CollectionGTMConstructor = class extends CollectionGTM {
    constructor(protected _collection: CollectionNode) {
        super()
    }
    get dimension4(): string {
        return this._collection.analyticsGradesDisplay
    }
}

export const PremiumCollectionGTM: PremiumCollectionGTMConstructor = class extends CollectionGTM {
    constructor(protected _collection: PremiumHomePage) {
        super()
    }
}

export const PremiumSubCollectionGTM: PremiumSubCollectionGTMConstructor = class extends CollectionGTM {
    constructor(protected _collection: PremiumSectionPage) {
        super()
    }
}
